/**
 * 🔍 بنك الكلمات المفتاحية المركزي لـ img.sa
 *
 * تجميع شامل لكل كلمات SEO المستهدفة لكل خدمة على المنصة.
 * كل صفحة تستخدم K.brand + كلمات الخدمة + كلمات المدن + الطويلة.
 *
 * 🎯 الهدف: تغطية كل عبارة بحث عقارية ممكنة بالعربي + الإنجليزي + المدن.
 */

// ━━━━━━━━━━━━━━━━ 1) العلامة والشركة ━━━━━━━━━━━━━━━━
export const K_BRAND = [
  'شركة صورة العقارية', 'صورة العقارية', 'شركة صورة', 'صورة الرياض', 'IMG SA', 'IMG.sa', 'img.sa',
  'Sora Real Estate', 'Sora Real Estate Company', 'العقار بصورة جديدة', 'منصة صورة', 'موقع صورة العقارية',
  'تطبيق صورة العقارية', 'شركة عقارية سعودية', 'شركة عقارية مرخصة',
  'علي الهويمل', 'علي بن فهد الهويمل', 'مؤسس صورة', 'شريك مؤسس', 'الرئيس التنفيذي صورة',
].join(', ');

// ━━━━━━━━━━━━━━━━ 2) النظام والتراخيص ━━━━━━━━━━━━━━━━
export const K_REGULATORY = [
  // الجهات الرسمية
  'الهيئة العامة للعقار', 'REGA', 'هيئة العقار السعودية', 'البورصة العقارية', 'البورصة العقارية السعودية',
  'منصة إيجار', 'إيجار', 'EJAR', 'منصة فال', 'FAL', 'ترخيص فال', 'ترخيص REGA', 'ترخيص الإعلان العقاري',
  'إعلان عقاري مرخص', 'إعلان مرخص', 'رقم ترخيص الإعلان', 'منصة ناجز', 'ناجز', 'وزارة العدل',
  'وزارة الإسكان', 'سكني', 'صندوق التنمية العقارية', 'صناديق REIT', 'صناديق عقارية متداولة',
  // التوثيق
  'الصك الإلكتروني', 'التوثيق الرقمي', 'الرهن العقاري الإلكتروني', 'العقود الموثقة', 'عقد إيجار موثق',
  'بيع موثق', 'تصرفات عقارية', 'ضريبة التصرفات العقارية', 'الزكاة العقارية', 'الرسوم البلدية',
  // الامتثال
  'الامتثال العقاري', 'حماية المستهلك العقاري', 'الشفافية العقارية', 'حقوق الملاك', 'حقوق المستأجرين',
  'نظام التسجيل العيني', 'سجل العقارات', 'هوية وطنية عقارية', 'نفاذ الوطني', 'Nafath',
].join(', ');

// ━━━━━━━━━━━━━━━━ 3) المدن السعودية الرئيسية ━━━━━━━━━━━━━━━━
export const K_CITIES = [
  // الكبرى
  'الرياض', 'جدة', 'الدمام', 'الخبر', 'مكة المكرمة', 'المدينة المنورة', 'الطائف', 'الأحساء', 'القطيف', 'بريدة',
  'تبوك', 'حائل', 'أبها', 'خميس مشيط', 'نجران', 'جازان', 'الباحة', 'عرعر', 'سكاكا', 'الجبيل', 'ينبع',
  'القصيم', 'حفر الباطن', 'القنفذة', 'وادي الدواسر',
  // عقار + مدينة (Long-tail قوي)
  'عقارات الرياض', 'عقارات جدة', 'عقارات الدمام', 'عقارات الخبر', 'عقارات مكة', 'عقارات المدينة',
  'عقارات الطائف', 'عقارات أبها', 'عقارات تبوك', 'عقارات نجران', 'عقارات حائل', 'عقارات بريدة', 'عقارات القصيم',
  // الأحياء الشهيرة
  'حي العليا', 'حي النخيل', 'حي الياسمين', 'حي الملقا', 'حي العقيق', 'حي الرحمانية', 'حي قرطبة',
  'حي الورود', 'حي الرائد', 'حي حطين', 'حي الصحافة', 'حي السليمانية', 'حي العزيزية', 'حي الحمراء',
  'حي الروضة', 'حي الشاطئ', 'حي الكورنيش', 'حي الزهراء', 'حي البساتين', 'حي الفيحاء',
  // المشاريع العملاقة
  'نيوم', 'NEOM', 'البحر الأحمر', 'القدية', 'روشن', 'ذا لاين', 'THE LINE', 'الدرعية', 'مشروع الرياض الخضراء',
  'مسار', 'مسار مكة', 'مشروع King Salman Park',
].join(', ');

// ━━━━━━━━━━━━━━━━ 4) العقارات (Properties) ━━━━━━━━━━━━━━━━
export const K_PROPERTIES = [
  // عام
  'عقارات', 'عقار', 'عقارات للبيع', 'عقارات للإيجار', 'عقارات للاستثمار', 'بيع عقار', 'شراء عقار',
  'إيجار عقار', 'استثمار عقاري', 'تأجير عقار', 'بحث عقاري', 'موقع عقاري', 'منصة عقارية', 'تطبيق عقاري',
  'سوق عقاري', 'سوق العقار السعودي', 'سوق العقار', 'أسعار العقار', 'مؤشر العقار', 'تقرير عقاري',
  // فلل
  'فلل', 'فلل للبيع', 'فلل للإيجار', 'فلل فاخرة', 'فلل دوبلكس', 'فلل مفروشة', 'فلل بمسبح', 'فلل حديثة',
  'فلل جديدة', 'فلل مع حديقة', 'فلل VIP', 'فيلا للبيع', 'فيلا للإيجار', 'فيلا فاخرة', 'فيلا مودرن',
  'فلل الرياض', 'فلل جدة', 'فلل الدمام', 'فلل الخبر', 'فلل مكة', 'فلل المدينة',
  // شقق
  'شقق', 'شقق للبيع', 'شقق للإيجار', 'شقق فاخرة', 'شقق مفروشة', 'شقق عوائل', 'شقق عزّاب', 'شقق دوبلكس',
  'شقق طابق كامل', 'شقق سكنية', 'شقق فندقية', 'بنتهاوس', 'استوديو', 'شقة غرفتين', 'شقة 3 غرف',
  'شقق الرياض', 'شقق جدة', 'شقق الدمام', 'شقق الخبر', 'شقق مكة', 'شقق المدينة',
  // أراضي
  'أراضي', 'أراضي للبيع', 'أراضي سكنية', 'أراضي تجارية', 'أراضي زراعية', 'أراضي صناعية',
  'أرض للبيع', 'أرض سكنية', 'أرض تجارية', 'أرض مخططة', 'أرض جنوب', 'أرض شمال', 'أرض شرق', 'أرض غرب',
  'مخططات سكنية', 'أراضي الرياض', 'أراضي جدة', 'أراضي الدمام', 'أراضي مكة', 'أراضي المدينة',
  // عمائر
  'عمائر', 'عمائر للبيع', 'عمائر استثمارية', 'عمائر سكنية', 'عمائر تجارية', 'عمارة للبيع', 'عمارة دخل',
  'استثمار في العمائر', 'عوائد العمائر', 'تطوير عمائر',
  // تجاري
  'محلات تجارية', 'محل للإيجار', 'محل للبيع', 'شو روم', 'معارض تجارية', 'مولات', 'مراكز تجارية',
  'مطاعم للبيع', 'مقاهي للبيع', 'صالونات للبيع', 'مغاسل للبيع', 'استثمار تجاري',
  // مكاتب
  'مكاتب', 'مكاتب للإيجار', 'مكاتب فاخرة', 'مكاتب إدارية', 'مكاتب طابق كامل', 'مساحات عمل مشتركة',
  'كوركينج سبيس', 'co-working', 'مكاتب الرياض', 'مكاتب جدة', 'مكاتب VIP',
  // مستودعات + مزارع
  'مستودعات', 'مستودعات للإيجار', 'مستودعات للبيع', 'مستودع كبير', 'مستودع صغير', 'مستودعات مبردة',
  'مزارع', 'مزارع للبيع', 'مزارع للاستثمار', 'مزرعة دواجن', 'مزرعة نخيل', 'مزرعة مفروشة',
  // استراحات
  'استراحات', 'استراحات للإيجار', 'استراحات فاخرة', 'استراحات بمسابح', 'استراحات يومية', 'استراحات شهرية',
  'شاليهات', 'شاليهات للإيجار', 'مخيمات', 'كوخ', 'كبائن',
  // أسئلة طويلة (Long-tail)
  'كيف أبيع عقاري', 'كيف أشتري بيت', 'كيف أؤجر عقاري', 'كيف أستثمر في العقار', 'أفضل وقت لشراء العقار',
  'هل العقار استثمار آمن', 'كم سعر العقار في الرياض', 'أرخص عقار في السعودية', 'أغلى عقار في السعودية',
  'عقارات بأسعار مناسبة', 'عقارات بالتقسيط', 'عقارات بدون فوائد', 'عقارات تمويل',
].join(', ');

// ━━━━━━━━━━━━━━━━ 5) المزادات العقارية ━━━━━━━━━━━━━━━━
export const K_AUCTIONS = [
  // عام
  'مزادات عقارية', 'مزاد عقاري', 'مزاد عقار', 'مزادات السعودية', 'مزاد مباشر', 'مزاد على الهواء',
  'مزاد إلكتروني', 'مزاد رقمي', 'مزاد علني', 'مزاد قضائي', 'مزاد رسمي', 'مزاد بيع', 'مزاد شراء',
  'مزاد عقاري الرياض', 'مزاد عقاري جدة', 'مزاد عقاري الدمام', 'مزاد عقاري مكة', 'مزاد عقاري المدينة',
  'مزاد فلل', 'مزاد شقق', 'مزاد أراضي', 'مزاد عمائر', 'مزاد محلات', 'مزاد مكاتب', 'مزاد مستودعات',
  'مزاد مزارع', 'مزاد استراحات',
  // عناصر المزاد
  'محرّج عقاري', 'محرّج معتمد', 'حراج عقاري', 'دلال عقاري', 'بائع المزاد', 'مشتري المزاد', 'مزايدة',
  'مزايدة عقارية', 'سعر افتتاح', 'حد أدنى للمزايدة', 'عمولة السعي', 'السعي', 'العمولة العقارية',
  'ضمان المزايدة', 'ضمان دخول المزاد', 'تأمين المزايدة',
  // تقنية
  'مزاد بثّ مباشر', 'بثّ المزاد', 'مزاد بالصوت والصورة', 'فيديو المزاد', 'بثّ حي للمزاد',
  'منصة مزادات إلكترونية', 'موقع مزادات', 'تطبيق مزادات', 'مزاد افتراضي', 'مزاد أونلاين',
  // طويلة
  'كيف أشترك في مزاد', 'كيف أقيم مزاد على عقاري', 'شروط المزاد العقاري', 'رسوم المزاد',
  'كيف يتم تسليم العقار بعد المزاد', 'ضمان المشتري في المزاد', 'مزاد بدون ضمان', 'مزاد بضمان',
  'أفضل منصة مزادات عقارية', 'مزادات صورة', 'مزادات IMG', 'أكبر مزاد عقاري',
].join(', ');

// ━━━━━━━━━━━━━━━━ 6) اتحاد الملاك (Mullak) ━━━━━━━━━━━━━━━━
export const K_MULLAK = [
  // عام
  'اتحاد الملاك', 'اتحاد ملاك', 'مُلّاك', 'إدارة اتحاد ملاك', 'جمعية الملاك', 'الجمعية العمومية',
  'جمعية عمومية لاتحاد ملاك', 'رئيس اتحاد الملاك', 'مدير اتحاد الملاك', 'محاضر الاجتماعات',
  'لائحة اتحاد الملاك', 'النظام الأساسي لاتحاد الملاك',
  // مرافق
  'المرافق المشتركة', 'الأجزاء المشتركة', 'صيانة المرافق', 'صيانة المصاعد', 'صيانة الحدائق',
  'صيانة المسابح', 'صيانة الإنارة', 'صيانة الواجهات', 'صيانة الأسطح', 'صيانة المولدات',
  'تنظيف المباني', 'حراسة المبنى', 'أمن المبنى', 'كاميرات المراقبة', 'إدارة المرافق', 'facility management',
  // مالية
  'رسوم اتحاد الملاك', 'رسوم صيانة', 'صندوق احتياطي', 'احتياطي الصيانة', 'دفعات اتحاد الملاك',
  'فواتير اتحاد الملاك', 'محصّل اتحاد الملاك', 'مصروفات اتحاد الملاك', 'موازنة اتحاد الملاك',
  // طويلة
  'كيف يتأسس اتحاد ملاك', 'دور اتحاد الملاك', 'حقوق الملاك في الأجزاء المشتركة',
  'كيف تُحل النزاعات بين الملاك', 'أنظمة اتحاد الملاك السعودية', 'لائحة اتحاد الملاك REGA',
  'منصة اتحاد ملاك', 'تطبيق اتحاد ملاك', 'برنامج إدارة اتحاد الملاك', 'مُلّاك صورة', 'منصة مُلّاك',
].join(', ');

// ━━━━━━━━━━━━━━━━ 7) الوسطاء/المسوّقون (Brokers) ━━━━━━━━━━━━━━━━
export const K_BROKERS = [
  'مسوّق عقاري', 'مسوّقون عقاريون', 'وسيط عقاري', 'وسطاء عقاريون', 'سمسار عقاري', 'سماسرة عقاريون',
  'وكيل عقاري', 'وكلاء عقاريون', 'مكتب عقاري', 'مكاتب عقارية', 'شركة عقارية', 'شركات عقارية',
  'مستشار عقاري', 'استشارات عقارية', 'مفاوضات عقارية', 'تسويق عقاري', 'إدارة عقارية',
  'انضم كمسوّق', 'وظائف عقارية', 'وظيفة وسيط عقاري', 'فرص عمل عقارية', 'عمولة المسوّق',
  'عمولة الوسيط', 'نسبة العمولة العقارية', 'وسيط عقاري معتمد', 'وسيط مرخص', 'رخصة فال',
  'مسوّق فال', 'كيف أكون وسيط عقاري', 'تدريب الوسطاء العقاريين', 'دورات عقارية', 'شهادة عقارية',
].join(', ');

// ━━━━━━━━━━━━━━━━ 8) الحاسبات الذكية ━━━━━━━━━━━━━━━━
export const K_CALCULATORS = [
  'حاسبة عقارية', 'حاسبات عقارية', 'أدوات عقارية', 'حاسبة الرهن العقاري', 'حاسبة التمويل العقاري',
  'حاسبة القسط الشهري', 'حاسبة الإيجار', 'حاسبة الإيجار السنوي', 'حاسبة العائد العقاري', 'ROI calculator',
  'حاسبة المساحة', 'تحويل المتر إلى القدم', 'حاسبة المساحات', 'حاسبة الزكاة العقارية',
  'حاسبة ضريبة التصرفات العقارية', 'حاسبة 5%', 'حاسبة رسوم البلدية', 'حاسبة عمولة الوسيط',
  'حاسبة السعي', 'حاسبة عمولة المزاد', 'حاسبة عقار رخيص', 'حاسبة استثمار عقاري',
  'حاسبة نسبة العائد', 'كم القسط الشهري للقرض العقاري', 'حساب القرض', 'تمويل عقاري بدون فوائد',
  'تمويل عقاري متوافق مع الشريعة', 'إجمالي تكلفة شراء العقار', 'تكلفة شراء فيلا', 'تكلفة شراء أرض',
].join(', ');

// ━━━━━━━━━━━━━━━━ 9) الخريطة العقارية ━━━━━━━━━━━━━━━━
export const K_MAP = [
  'خريطة العقارات', 'العقارات على الخريطة', 'بحث عقاري بالخريطة', 'خريطة عقارية تفاعلية',
  'عقارات قريبة مني', 'عقارات في حيّي', 'خريطة فلل', 'خريطة شقق', 'خريطة أراضي', 'خريطة الرياض العقارية',
  'خريطة جدة العقارية', 'موقع عقاري', 'إحداثيات العقار', 'GPS عقاري', 'تحديد موقع العقار',
  'عرض جغرافي للعقارات', 'اكتشاف عقارات حسب المنطقة', 'فلتر بحث عقاري', 'بحث متقدم عن العقار',
].join(', ');

// ━━━━━━━━━━━━━━━━ 10) التصميم الهندسي والاستشارات ━━━━━━━━━━━━━━━━
export const K_ENGINEERING = [
  'تصميم هندسي', 'تصميم معماري', 'تصميم داخلي', 'هندسة إنشائية', 'استشارات هندسية', 'مكتب هندسي',
  'مكاتب هندسية', 'مهندس معماري', 'مهندس إنشائي', 'مخططات معمارية', 'رسومات هندسية', 'مخطط فيلا',
  'مخطط منزل', 'مخطط شقة', 'مخطط دور', 'تصميم واجهة', 'تصميم فيلا فاخرة', 'تصميم منزل عصري',
  'تصميم منزل تراثي', 'تصميم منزل أوروبي', 'تصميم 3D', '3D rendering', 'visualization عقارية',
  'مشاريع هندسية', 'إشراف هندسي', 'تنفيذ مشاريع', 'دراسات جدوى عقارية', 'تخطيط عمراني',
  'تطوير عقاري', 'تطوير أراضي', 'فرز أراضي', 'تقسيم أراضي', 'هدم وإعادة بناء',
].join(', ');

// ━━━━━━━━━━━━━━━━ 11) خدمات الصيانة والمرافق (Facility) ━━━━━━━━━━━━━━━━
export const K_FACILITY = [
  'صيانة عقارية', 'صيانة المباني', 'صيانة المنازل', 'صيانة الفلل', 'صيانة الشقق', 'صيانة العمائر',
  'سباكة', 'كهرباء', 'تكييف وتبريد', 'تكييف مركزي', 'سبليت', 'صيانة سبليت', 'صيانة مكيفات',
  'صيانة طارئة', 'صيانة دورية', 'صيانة وقائية', 'فني سباكة', 'فني كهرباء', 'فني تكييف',
  'تنظيف عام', 'تنظيف فلل', 'تنظيف شقق', 'تنظيف ما بعد البناء', 'تنظيف الواجهات', 'تنظيف الخزانات',
  'مكافحة حشرات', 'رش مبيدات', 'تعقيم وتطهير', 'صيانة المسابح', 'صيانة الحدائق', 'تنسيق حدائق',
  'صبغ ودهانات', 'تركيب أرضيات', 'تركيب باركيه', 'تركيب رخام', 'ترميم منازل', 'مقاولات صيانة',
  'طلب صيانة عقارية', 'أفضل شركة صيانة', 'صيانة مباني تجارية',
].join(', ');

// ━━━━━━━━━━━━━━━━ 12) أنواع البحث الطويلة (Long-tail) ━━━━━━━━━━━━━━━━
export const K_LONGTAIL = [
  'أفضل شركة عقارية في السعودية', 'أفضل موقع عقارات سعودي', 'أفضل تطبيق عقارات',
  'أين أعلن عن عقاري', 'كيف أبيع عقاري بأفضل سعر', 'كيف أشتري بيت بأمان', 'هل العقار استثمار آمن',
  'أرخص عقارات في الرياض', 'أفخم عقارات في جدة', 'فلل للبيع تحت 2 مليون', 'شقق للبيع تحت مليون',
  'أراضي تحت 500 ألف', 'أراضي للاستثمار بأسعار مناسبة', 'عمائر دخل في السعودية',
  'استثمار عقاري بدون مخاطرة', 'تأجير عقار ضمان', 'إيجار سنوي', 'إيجار شهري', 'إيجار يومي',
  'عقارات مع تأمين', 'عقارات بضمان شركة صورة', 'العقار بصورة جديدة', 'منصة عقارية موثوقة',
  'عقارات بالتقسيط', 'عقارات بدون مقدّم', 'عقارات بتمويل بنكي', 'عقارات بتمويل صندوق',
  'عقارات للبيع نقدي', 'عقارات بالتقسيط المريح', 'مزادات صورة العقارية',
].join(', ');

// ━━━━━━━━━━━━━━━━ كومبو سريع لكل صفحة ━━━━━━━━━━━━━━━━

/** كلمات الصفحة الرئيسية — تشمل كل خدماتنا الأساسية */
export const KEYWORDS_HOME = [K_BRAND, K_PROPERTIES, K_AUCTIONS, K_MULLAK, K_BROKERS, K_REGULATORY, K_CITIES, K_LONGTAIL].join(', ');

/** كلمات صفحة العقارات */
export const KEYWORDS_PROPERTIES = [K_BRAND, K_PROPERTIES, K_CITIES, K_REGULATORY, K_LONGTAIL].join(', ');

/** كلمات صفحة المزادات */
export const KEYWORDS_AUCTIONS = [K_BRAND, K_AUCTIONS, K_PROPERTIES, K_CITIES, K_REGULATORY].join(', ');

/** كلمات صفحة اتحاد الملاك */
export const KEYWORDS_MULLAK = [K_BRAND, K_MULLAK, K_FACILITY, K_CITIES, K_REGULATORY].join(', ');

/** كلمات صفحة المسوّقين */
export const KEYWORDS_BROKERS = [K_BRAND, K_BROKERS, K_PROPERTIES, K_CITIES, K_REGULATORY].join(', ');

/** كلمات صفحة الحاسبات */
export const KEYWORDS_CALCULATORS = [K_BRAND, K_CALCULATORS, K_PROPERTIES, K_REGULATORY].join(', ');

/** كلمات صفحة الخريطة */
export const KEYWORDS_MAP = [K_BRAND, K_MAP, K_PROPERTIES, K_CITIES].join(', ');

/** كلمات صفحة التصميم الهندسي */
export const KEYWORDS_ENGINEERING = [K_BRAND, K_ENGINEERING, K_PROPERTIES, K_CITIES].join(', ');

/** كلمات صفحة الصيانة والمرافق */
export const KEYWORDS_FACILITY = [K_BRAND, K_FACILITY, K_MULLAK, K_CITIES].join(', ');
